import React, { createContext, useState } from 'react';
import VideoPlayerModal from './VideoPlayerModal';

interface ModalState {
  show: boolean;
  id?: string;
  data?: any;
}

interface ModalContextType {
  modalState: ModalState;
  updateState: (state: any) => void;
}

export const ModalContext = createContext<ModalContextType>({
  modalState: {
    show: false,
    id: undefined,
    data: undefined,
  },
  updateState: (state: ModalState) => {},
});

export const ModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState<ModalState>({ 
    show: false,
    id: undefined,
    data: undefined,
   });

  const updateState = (newState: any) => {
    console.log(newState);
    setModalState({ ...modalState, ...newState });
  };

  const onUpdate = (footage: any) => {
    console.log(footage);
  };

  return (
    <ModalContext.Provider value={{ modalState, updateState }}>
      {children}
      <VideoPlayerModal show={modalState.show} data={modalState.data} onClose={() => updateState({ show: false })} onUpdate={onUpdate} />
    </ModalContext.Provider>

  );
};